import { useStaticQuery, graphql } from 'gatsby';

export const useSiteSettings = () => {
    const {
        wp: {
            siteSettings: { siteSettings }
        }
    } = useStaticQuery(graphql`
        query {
            wp {
                siteSettings {
                    siteSettings {
                        appLinks {
                            linkUrl
                            badge {
                                id
                                altText
                                sourceUrl
                                localFile {
                                    childImageSharp {
                                        gatsbyImageData(aspectRatio: 3)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return siteSettings;
};
